// import React, { useEffect } from "react";
// import { useNavigate } from "react-router-dom";

// const SplashScreen = () => {
//   const navigate = useNavigate();

//   useEffect(() => {
//     const timer = setTimeout(() => {
//       navigate("/home"); // 🔥 apna route set kar lena
//     }, 2500);

//     return () => clearTimeout(timer);
//   }, [navigate]);

//   return (
//     <>
//       <div style={styles.container}>
        
//         {/* 🔥 LOGO */}
//         <img
//           src="/logo.png" // 🔥 apna logo path
//           alt="School Logo"
//           style={styles.logo}
//         />

//         {/* 🔥 TITLE */}
//         <h1 style={styles.title}>DPS Kids Ladwa</h1>

//         {/* 🔥 TAGLINE */}
//         <p style={styles.tagline}>
//           We Build the Citizens of Tomorrow
//         </p>

//         {/* 🔥 LOADER */}
//         <div style={styles.loader}></div>

//       </div>

//       {/* 🔥 ANIMATIONS */}
//       <style>{`
//         @keyframes fadeIn {
//           from { opacity: 0; transform: translateY(20px); }
//           to { opacity: 1; transform: translateY(0); }
//         }

//         @keyframes zoomIn {
//           from { transform: scale(0.5); opacity: 0; }
//           to { transform: scale(1); opacity: 1; }
//         }

//         @keyframes spin {
//           0% { transform: rotate(0deg); }
//           100% { transform: rotate(360deg); }
//         }
//       `}</style>
//     </>
//   );
// };

// export default SplashScreen;

// const styles = {
//   container: {
//     height: "100vh",
//     width: "100%",
//     background: "linear-gradient(135deg, rgb(0,111,47), #000)",
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",
//     justifyContent: "center",
//     color: "#fff",
//     textAlign: "center",
//     padding: "20px",
//   },

//   logo: {
//     width: "clamp(80px, 20vw, 140px)",
//     marginBottom: "20px",
//     animation: "zoomIn 1.2s ease",
//   },

//   title: {
//     fontSize: "clamp(22px, 6vw, 40px)",
//     fontWeight: "800",
//     marginBottom: "8px",
//     animation: "fadeIn 1.5s ease",
//   },

//   tagline: {
//     fontSize: "clamp(12px, 2.5vw, 18px)",
//     opacity: 0.85,
//     marginBottom: "30px",
//     animation: "fadeIn 2s ease",
//   },

//   loader: {
//     width: "40px",
//     height: "40px",
//     border: "4px solid rgba(255,255,255,0.3)",
//     borderTop: "4px solid #fff",
//     borderRadius: "50%",
//     animation: "spin 1s linear infinite",
//   },
// };

// import React, { useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import logo from "../Screenss/dpslogo.png"; // ✅ correct import
 
// const SplashScreen = () => {
//   const navigate = useNavigate();

//   useEffect(() => {
//     const timer = setTimeout(() => {
//       navigate("/home");
//     }, 2800);

//     return () => clearTimeout(timer);
//   }, [navigate]);

//   return (
//     <>
//       <div style={styles.container}>

//         {/* 🔥 GLASS CARD */}
//         <div style={styles.card}>

//           {/* 🔥 LOGO */}
//           <img src={logo} alt="School Logo" style={styles.logo} />

//           {/* 🔥 TITLE */}
//           <h1 style={styles.title}>DPS Kids Ladwa</h1>

//           {/* 🔥 TAGLINE */}
//           <p style={styles.tagline}>
//             We Build the Citizens of Tomorrow
//           </p>

//           {/* 🔥 MODERN LOADER */}
//           <div style={styles.loaderWrap}>
//             <div style={styles.loader}></div>
//           </div>

//         </div>
//       </div>

//       {/* 🔥 ANIMATIONS */}
//       <style>{`
//         @keyframes fadeUp {
//           from { opacity: 0; transform: translateY(30px); }
//           to { opacity: 1; transform: translateY(0); }
//         }

//         @keyframes zoom {
//           from { transform: scale(0.6); opacity: 0; }
//           to { transform: scale(1); opacity: 1; }
//         }

//         @keyframes spinGlow {
//           0% { transform: rotate(0deg); }
//           100% { transform: rotate(360deg); }
//         }

//         @keyframes pulse {
//           0% { box-shadow: 0 0 0px rgba(0,255,150,0.4); }
//           50% { box-shadow: 0 0 25px rgba(0,255,150,0.6); }
//           100% { box-shadow: 0 0 0px rgba(0,255,150,0.4); }
//         }
//       `}</style>
//     </>
//   );
// };

// export default SplashScreen;

// const styles = {
//   container: {
//     height: "100vh",
//     width: "100%",
//     background: "linear-gradient(135deg, #001f0f, rgb(0,111,47))",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     padding: "20px",
//   },

//   card: {
//     backdropFilter: "blur(15px)",
//     background: "rgba(255,255,255,0.08)",
//     borderRadius: "25px",
//     padding: "40px 30px",
//     textAlign: "center",
//     color: "#fff",
//     animation: "fadeUp 1.2s ease",
//     border: "1px solid rgba(255,255,255,0.15)",
//     boxShadow: "0 10px 40px rgba(0,0,0,0.3)",
//     maxWidth: "320px",
//     width: "100%",
//   },

//   logo: {
//     width: "clamp(90px, 25vw, 140px)",
//     marginBottom: "15px",
//     animation: "zoom 1.2s ease",
//   },

//   title: {
//     fontSize: "clamp(20px, 5vw, 34px)",
//     fontWeight: "800",
//     marginBottom: "6px",
//     letterSpacing: "1px",
//   },

//   tagline: {
//     fontSize: "clamp(12px, 2.5vw, 16px)",
//     opacity: 0.85,
//     marginBottom: "25px",
//   },

//   loaderWrap: {
//     display: "flex",
//     justifyContent: "center",
//   },

//   loader: {
//     width: "45px",
//     height: "45px",
//     border: "3px solid rgba(255,255,255,0.2)",
//     borderTop: "3px solid #00ff9c",
//     borderRadius: "50%",
//     animation: "spinGlow 1s linear infinite, pulse 2s infinite",
//   },
// };

import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../Screenss/dpslogo.png";

const SplashScreen = () => {
  const navigate = useNavigate();

//   useEffect(() => {
//     const timer = setTimeout(() => {
//       navigate("/home");
//     }, 2800);

//     return () => clearTimeout(timer);
//   }, [navigate]);
useEffect(() => {
  const hasVisited = sessionStorage.getItem("visited");

  if (!hasVisited) {
    const timer = setTimeout(() => {
      sessionStorage.setItem("visited", "true");
      navigate("/homee");
    }, 2800);

    return () => clearTimeout(timer);
  } else {
    navigate("/homee"); // 🔥 direct skip splash
  }
}, [navigate]);

  return (
    <>
      <div style={styles.container}>

        {/* 🔥 CENTER CARD */}
        <div style={styles.card}>

          <img src={logo} alt="School Logo" style={styles.logo} />

          <h1 style={styles.title}>DPS Kids Ladwa</h1>

          <p style={styles.tagline}>
            We Build the Citizens of Tomorrow
          </p>

          <div style={styles.loader}></div>

        </div>
      </div>

      {/* 🔥 ANIMATIONS */}
      <style>{`
        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(40px); }
          to { opacity: 1; transform: translateY(0); }
        }

        @keyframes zoom {
          from { transform: scale(0.7); opacity: 0; }
          to { transform: scale(1); opacity: 1; }
        }

        @keyframes spin {
          to { transform: rotate(360deg); }
        }

        @keyframes glow {
          0% { box-shadow: 0 0 0 rgba(0,255,150,0.3); }
          50% { box-shadow: 0 0 20px rgba(0,255,150,0.6); }
          100% { box-shadow: 0 0 0 rgba(0,255,150,0.3); }
        }
      `}</style>
    </>
  );
};

export default SplashScreen;

// /* 🔥 STYLES */
// const styles = {
//   container: {
//     height: "100vh",
//     width: "100%",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     padding: "clamp(15px, 4vw, 30px)",
//     background: `
//       radial-gradient(circle at top, rgba(0,111,47,0.6), transparent),
//       linear-gradient(135deg, #001f0f, rgb(0,111,47))
//     `,
//   },

//   card: {
//     width: "100%",
//     maxWidth: "clamp(280px, 80vw, 360px)", // 🔥 better scaling
//     padding: "clamp(25px, 6vw, 45px) clamp(20px, 5vw, 35px)",
//     borderRadius: "24px",
//     textAlign: "center",
//     color: "#fff",
//     backdropFilter: "blur(18px)",
//     background: "rgba(255,255,255,0.08)",
//     border: "1px solid rgba(255,255,255,0.15)",
//     boxShadow: "0 20px 50px rgba(0,0,0,0.35)",
//     animation: "fadeUp 1.2s ease",
//   },

//   logo: {
//     width: "clamp(80px, 22vw, 130px)",
//     marginBottom: "12px",
//     animation: "zoom 1s ease",
//   },

//   title: {
//     fontSize: "clamp(20px, 5vw, 32px)",
//     fontWeight: "800",
//     marginBottom: "6px",
//     letterSpacing: "0.5px",
//   },

//   tagline: {
//     fontSize: "clamp(12px, 2.5vw, 15px)",
//     opacity: 0.85,
//     marginBottom: "28px",
//     lineHeight: "1.5",
//   },

//   loader: {
//     margin: "0 auto",
//     width: "42px",
//     height: "42px",
//     borderRadius: "50%",
//     border: "3px solid rgba(255,255,255,0.25)",
//     borderTop: "3px solid #00ff9c",
//     animation: "spin 1s linear infinite, glow 2s infinite",
//   },
// };

const styles = {
  container: {
    position: "fixed", // 🔥 full screen lock
    inset: 0, // 🔥 top:0 left:0 right:0 bottom:0
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: `
      radial-gradient(circle at top, rgba(0,111,47,0.6), transparent),
      linear-gradient(135deg, #001f0f, rgb(0,111,47))
    `,
    overflow: "hidden", // 🔥 no scroll
  },

  card: {
    width: "90%", // 🔥 fixed width control
    maxWidth: "340px", // 🔥 desktop limit
    padding: "30px 20px", // 🔥 no clamp → stable
    borderRadius: "20px",
    textAlign: "center",
    color: "#fff",
    backdropFilter: "blur(18px)",
    background: "rgba(255,255,255,0.08)",
    border: "1px solid rgba(255,255,255,0.15)",
    boxShadow: "0 20px 50px rgba(0,0,0,0.35)",
    animation: "fadeUp 1.2s ease",
  },

  logo: {
    width: "110px", // 🔥 stable (no jump)
    maxWidth: "40%",
    marginBottom: "12px",
    animation: "zoom 1s ease",
  },

  title: {
    fontSize: "24px",
    fontWeight: "800",
    marginBottom: "6px",
  },

  tagline: {
    fontSize: "14px",
    opacity: 0.85,
    marginBottom: "25px",
  },

  loader: {
    margin: "0 auto",
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    border: "3px solid rgba(255,255,255,0.25)",
    borderTop: "3px solid #00ff9c",
    animation: "spin 1s linear infinite",
  },
};